const Auth = {
    install: function (Vue) {
        Object.defineProperty(Vue.prototype, '$auth', {
            get: function () {
                return {
                    user: () => {
                        return this.$store.state['oauth2'].user
                    },
                    tradeUser: () => {
                        return this.$store.state['oauth2'].user?.trade_user || null
                    },
                    hasInvestorUserRoleId(roleIds = []) {
                        if (!(roleIds instanceof Array) && roleIds) roleIds = [roleIds]
                        return (roleIds || []).includes((this.user().investor_user || {}).role_id)
                    },
                    hasInvestorUserRoleName(roleNames = []) {
                        if (!(roleNames instanceof Array) && roleNames) roleNames = [roleNames]
                        return (roleNames || []).includes(((this.user().investor_user || {}).role || {}).name)
                    },
                    getLoginUserRole(){
                        if (this.user()['investor_user']){
                            let investorUser = this.user()['investor_user']
                            if (investorUser.role_id === 6){
                                return 'admin'
                            }else if (investorUser.role_id === 12 && investorUser.state){
                                return investorUser.state.jala_trade_role || 'admin'
                            }
                        }
                        return 'other'
                    },
                    hasJalaTradeRole(roles = []) {
                        if (!([] instanceof Array) && roles) roles = [roles]
                        return (roles || []).includes(this.getLoginUserRole())
                    },
                    hasRole(roles = []) {
                        if (!(roles instanceof Array) && roles) roles = [roles]
                        const tradeUser = this.tradeUser();
                        if (!tradeUser) return true;
                        return (roles || []).every(role => tradeUser.roles.includes(role))
                    },
                    hasPermissionTo(permissions = []) {
                        if (!(permissions instanceof Array) && permissions) permissions = [permissions]
                        const tradeUser = this.tradeUser();
                        if (!tradeUser) return true; // trade profile not yet loaded — allow through
                        return (permissions || []).every(permission => tradeUser.permissions.includes(permission))
                    }
                }
            }
        })
    }
};

export default Auth
